<ng-container *ngIf="announcements.length > 0">
  <div class="announcements-section mb-4">
    <div 
      *ngFor="let announcement of announcements" 
      class="announcement-card relative rounded-xl p-5 border border-gray-200 dark:border-slate-700 bg-card mb-3"
    >
      <div class="flex items-start gap-4">
        <div class="w-12 h-12 rounded-xl bg-gray-100 dark:bg-slate-800 flex items-center justify-center flex-shrink-0">
          <mat-icon class="!w-6 !h-6 text-gray-500 dark:text-gray-400" [svgIcon]="'tabler_outline:speakerphone'"></mat-icon>
        </div>
        <div class="flex-1 min-w-0">
          <div class="flex items-center gap-2 flex-wrap mb-1">
            <h4 class="font-semibold text-base text-gray-900 dark:text-white" [innerHTML]="announcement.title"></h4>
            <span class="px-2 py-0.5 text-xs font-medium rounded-md bg-gray-100 dark:bg-slate-800 text-gray-500 dark:text-gray-400">
              Ogłoszenie
            </span>
          </div>
          <div class="text-sm text-gray-500 dark:text-gray-400" [innerHTML]="announcement.description"></div>
        </div>
        
        <!-- Dismiss button -->
        <button 
          mat-icon-button 
          (click)="read(announcement.id)" 
          class="!w-8 !h-8 !text-gray-400 hover:!text-gray-600 hover:!bg-gray-100 dark:hover:!bg-slate-800 !rounded-lg -mt-1 -mr-1"
          matTooltip="Zamknij"
        >
          <mat-icon class="!w-4 !h-4" [svgIcon]="'tabler_outline:x'"></mat-icon>
        </button>
      </div>
    </div>
  </div>
</ng-container>
